import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

// Also send Bearer token if we have one in memory (belt-and-braces)
let _token = null;
export function setAuthToken(t) {
    _token = t;
    if (t) localStorage.setItem("exprivia_token", t);
    else localStorage.removeItem("exprivia_token");
}
export function getAuthToken() {
    if (_token) return _token;
    try { return localStorage.getItem("exprivia_token"); } catch { return null; }
}

api.interceptors.request.use((config) => {
    const t = getAuthToken();
    if (t && !config.headers.Authorization) {
        config.headers.Authorization = `Bearer ${t}`;
    }
    return config;
});

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export default api;
